// Single source of truth for screen sizes (IB-1885). The app used to hard-code 480/780 in ~60
// places, which sent every iPad (768-1024px) down the full desktop layout with a 250px sidebar.
//
//   mobile   0    - 599   phones
//   tablet   600  - 1023  tablets and small windows; uses the mobile navigation
//   laptop   1024 - 1439  13-15" laptops; desktop layout at a compact density
//   desktop  1440+        large monitors; desktop layout at full size
export const BREAKPOINTS = {
  tablet: 600,
  laptop: 1024,
  desktop: 1440,
};

// The compact density covers laptops at 100% browser zoom (1366/1440/1536px wide), which
// previously needed the browser zoomed out to ~90% before tables and buttons fitted.
export const COMPACT_MAX_WIDTH = 1599;
export const COMPACT_SCALE = 0.9;

// The sidebar starts collapsed below this width so content gets the room instead of the menu.
export const SIDEBAR_AUTO_COLLAPSE_WIDTH = 1280;

export type ScreenFlags = {
  isMobile: boolean;
  isTablet: boolean;
  isWeb: boolean;
};

export const getScreenFlags = (width: number = window.innerWidth): ScreenFlags => ({
  isMobile: width < BREAKPOINTS.tablet,
  isTablet: width >= BREAKPOINTS.tablet && width < BREAKPOINTS.laptop,
  isWeb: width >= BREAKPOINTS.laptop,
});

// Read once at load, like the constants this replaces: a device does not change class mid-session,
// and re-evaluating per render would remount whole layouts while a user is typing into a form.
export const SCREEN = getScreenFlags();

export const media = {
  mobile: `@media screen and (max-width: ${BREAKPOINTS.tablet - 1}px)`,
  tablet: `@media screen and (min-width: ${BREAKPOINTS.tablet}px) and (max-width: ${BREAKPOINTS.laptop - 1}px)`,
  belowLaptop: `@media screen and (max-width: ${BREAKPOINTS.laptop - 1}px)`,
  laptop: `@media screen and (min-width: ${BREAKPOINTS.laptop}px) and (max-width: ${BREAKPOINTS.desktop - 1}px)`,
  desktop: `@media screen and (min-width: ${BREAKPOINTS.desktop}px)`,
  compact: `@media screen and (min-width: ${BREAKPOINTS.laptop}px) and (max-width: ${COMPACT_MAX_WIDTH}px)`,
};
